import React, { useMemo, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { getApiErrorMessage, portNumber, resolveCompanyId } from './CallCenterService';
import './CallCenter.css';

export default function PortNumberPage() {
  const authContext = useAuth();
  const companyId = useMemo(() => resolveCompanyId(authContext?.additionalUserInfo), [authContext?.additionalUserInfo]);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [currentCarrier, setCurrentCarrier] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        phoneNumber,
        accountNumber,
        currentCarrier,
        ownerName,
      };

      await portNumber(authContext.token, companyId, payload);
      setSuccess('Porting request submitted successfully.');
      setPhoneNumber('');
      setAccountNumber('');
      setCurrentCarrier('');
      setOwnerName('');
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="call-center-page">
      <h1 className="call-center-title">Port Number</h1>
      <p className="call-center-subtitle">Submit your existing number details to request number porting.</p>

      <form className="call-center-card" onSubmit={onSubmit}>
        <div className="call-center-grid">
          <label className="call-center-field">
            Number to Port
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="e.g. +61412345678"
              required
            />
          </label>

          <label className="call-center-field">
            Existing Account Number
            <input
              type="text"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              placeholder="Carrier account number"
            />
          </label>

          <label className="call-center-field">
            Current Carrier
            <input
              type="text"
              value={currentCarrier}
              onChange={(e) => setCurrentCarrier(e.target.value)}
              placeholder="e.g. Telstra"
            />
          </label>

          <label className="call-center-field">
            Account Owner Name
            <input
              type="text"
              value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)}
              placeholder="Legal account owner name"
            />
          </label>
        </div>

        <div className="call-center-actions">
          <button className="call-center-btn" type="submit" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Port Request'}
          </button>
        </div>

        {error && <div className="call-center-message call-center-message-error">{error}</div>}
        {success && <div className="call-center-message call-center-message-success">{success}</div>}
      </form>
    </div>
  );
}
